export const state = [
  { value: "", name: "All States", id: "" },
  { value: "Abia", name: "Abia", id: "Abia" },
  { value: "Adamawa", name: "Adamawa", id: "Adamawa" },
  { value: "Akwa Ibom", name: "Akwa Ibom", id: "Akwa Ibom" },
  { value: "Anambra", name: "Anambra", id: "Anambra" },
  { value: "Bauchi", name: "Bauchi", id: "Bauchi" },
  { value: "Bayelsa", name: "Bayelsa", id: "Bayelsa" },
  { value: "Benue", name: "Benue", id: "Benue" },
  { value: "Borno", name: "Borno", id: "Borno" },
  { value: "Cross River", name: "Cross River", id: "Cross River" },
  { value: "Delta", name: "Delta", id: "Delta" },
  { value: "Ebonyi", name: "Ebonyi", id: "Ebonyi" },
  { value: "Edo", name: "Edo", id: "Edo" },
  { value: "Ekiti", name: "Ekiti", id: "Ekiti" },
  { value: "Enugu", name: "Enugu", id: "Enugu" },
  { value: "Gombe", name: "Gombe", id: "Gombe" },
  { value: "Imo", name: "Imo", id: "Imo" },
  { value: "Jigawa", name: "Jigawa", id: "Jigawa" },
  { value: "Kaduna", name: "Kaduna", id: "Kaduna" },
  { value: "Kano", name: "Kano", id: "Kano" },
  { value: "Katsina", name: "Katsina", id: "Katsina" },
  { value: "Kebbi", name: "Kebbi", id: "Kebbi" },
  { value: "Kogi", name: "Kogi", id: "Kogi" },
  { value: "Kwara", name: "Kwara", id: "Kwara" },
  { value: "Lagos", name: "Lagos", id: "Lagos" },
  { value: "Nasarawa", name: "Nasarawa", id: "Nasarawa" },
  { value: "Niger", name: "Niger", id: "Niger" },
  { value: "Ogun", name: "Ogun", id: "Ogun" },
  { value: "Ondo", name: "Ondo", id: "Ondo" },
  { value: "Osun", name: "Osun", id: "Osun" },
  { value: "Oyo", name: "Oyo", id: "Oyo" },
  { value: "Plateau", name: "Plateau", id: "Plateau" },
  { value: "Rivers", name: "Rivers", id: "Rivers" },
  { value: "Sokoto", name: "Sokoto", id: "Sokoto" },
  { value: "Taraba", name: "Taraba", id: "Taraba" },
  { value: "Yobe", name: "Yobe", id: "Yobe" },
  { value: "Zamfara", name: "Zamfara", id: "Zamfara" },
  { value: "FCT Abuja", name: "FCT Abuja", id: "FCT Abuja" },
];

export const propType = [
  { value: "Rent", name: "Rent", id: "Rent" },
  { value: "Sell", name: "Sale", id: "Sell" },
];

export const propUse = [
  { value: "Residential", name: "Residential", id: "Residential" },
  { value: "Commercial", name: "Commercial", id: "Commercial" },
];

export const propCat = [
  { value: "Flats", name: "Flats", id: "Flats" },
  { value: "Duplex", name: "Duplex", id: "Duplex" },
  { value: "Bungalow", name: "Bungalow", id: "Bungalow" },
  { value: "Apartments", name: "Apartments", id: "Apartments" },
  { value: "Shortlets", name: "Shortlets", id: "Shortlets" },
];
export const commCat = [
  { value: "Warehouses", name: "Warehouses", id: "Warehouses" },
  { value: "Co-working Space", name: "Co-working Space", id: "Co-working Space" },
  { value: "Office Building", name: "Office Building", id: "Office Building" },
  { value: "Hall", name: "Hall", id: "Hall" },
  { value: "Shortlets", name: "Shortlets", id: "Shortlets" },
];

export  const optionsPrice = [
    { value: "High to Low", name: "High to Low", id: "High to Low" },
    { value: "Low to High", name: "Low to High", id: "Low to High" },
  ]